import { FC, useMemo, useState } from 'react';
import { isEmpty } from 'lodash';

import { AppRoutes, PageSpinner, ProviderRoot } from '@app/components';
import { PatronSession, useAppUsers, useFeatureFlag } from '@app/hooks';
import { parseJSON } from '@app/utils';
import { Feature, SetState, UserSession } from '@app/constants';

import { ThemingConfig } from './ThemingConfig';

interface AppReadyProps {
  bannerMessage: string;
  setIsOkapiSessionDown: SetState<boolean>;
}

export type PatronSessionState = PatronSession | null;

export const AppReady: FC<AppReadyProps> = ({
  bannerMessage,
  setIsOkapiSessionDown,
}) => {
  const [patronSession, setPatronSession] = useState<PatronSessionState>(null);
  const { isActive: isConsortiaLogin } = useFeatureFlag({
    name: Feature.consortiaLoginFlow,
  });
  const {
    isPatronUserLoggedIn,
    isTransferSavedActivityLoading,
    authenticateToken,
  } = useAppUsers({
    patronSession,
    isConsortiaLogin,
    setPatronSession,
    setIsOkapiSessionDown,
  });
  const patronSessionFromStorage = parseJSON(
    sessionStorage.getItem(UserSession.patron),
    {}
  );

  const appContext = useMemo(
    () => ({
      isLoggedIn: isPatronUserLoggedIn,
      patronSession,
      bannerMessage,
      setPatronSession,
      authenticateToken,
    }),
    [
      isPatronUserLoggedIn,
      patronSession,
      bannerMessage,
      setPatronSession,
      authenticateToken,
    ]
  );

  if (
    (!isEmpty(patronSessionFromStorage) && !isPatronUserLoggedIn) ||
    isTransferSavedActivityLoading
  ) {
    return <PageSpinner />;
  }

  return (
    <ProviderRoot appContext={appContext}>
      <ThemingConfig />
      <AppRoutes />
    </ProviderRoot>
  );
};
